import { components } from '@/framework';

export default {
  install(Vue) {
    components(Vue, []);
  },
};



// WEBPACK FOOTER //
// ./src/components/index.js